import { categories, navLinks, siteInfo } from "@/mocks/portal";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer id="contact" className="w-full bg-secondary-950 text-background-100">
      <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-cursor-line text-xl"></i>
              </span>
              <span className="font-heading font-bold text-xl text-background-50">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm text-background-200 leading-relaxed max-w-md">
              {siteInfo.slogan}。我们持续把分散的热点与分类内容整理成清晰的直达通道，让你打开就能抵达感兴趣的分区。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href={`mailto:${siteInfo.email}`}
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
              >
                <i className="ri-mail-send-line"></i>
                联系编辑团队
              </a>
              <a
                href="#top"
                className="inline-flex items-center gap-2 rounded-md border border-background-100/25 px-4 py-2 text-sm font-medium text-background-100 whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50/10"
              >
                <i className="ri-arrow-up-line"></i>
                回到顶部
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-200 cursor-pointer transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50">内容分区</h3>
            <ul className="mt-4 space-y-2.5">
              {categories
                .filter((c) => c !== "全部")
                .map((category) => (
                  <li key={category}>
                    <a
                      href="#category"
                      className="text-sm text-background-200 cursor-pointer transition-colors hover:text-background-50"
                    >
                      {category}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/15 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-xs md:text-sm text-background-300">
            © {year} {siteInfo.name} · 内容直达门户 · 保留所有权利
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs md:text-sm text-background-300">
            <a href={`mailto:${siteInfo.email}`} className="cursor-pointer transition-colors hover:text-background-50">
              {siteInfo.email}
            </a>
            <a
              href={`mailto:${siteInfo.cooperation}`}
              className="cursor-pointer transition-colors hover:text-background-50"
            >
              商务合作：{siteInfo.cooperation}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}